import type { Resource } from '../../';
export const product_sizeChart_category_youth: Resource = {"default":"Youth"};
